module.exports = __webpack_public_path__ + "static/sm_img05@2x-39321dc9a79d125b0fa1011ad34ab72d.jpg";